import React from 'react';
import './PrivacyPolicyPage.css'; // Создадим этот файл позже, если потребуется стилизация

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Политика конфиденциальности</h1>
      <p>Дата вступления в силу: 25 июня 2025 г.</p>

      <p>
        Эта Политика конфиденциальности описывает, как мы обрабатываем информацию при использовании вами нашего сервиса.
        Мы ценим вашу конфиденциальность и стремимся обеспечить максимальную защиту ваших данных.
      </p>

      <h2>Сбор и использование информации</h2>
      <p>
        Мы хотим четко заявить, что <strong>мы не собираем, не храним и не обрабатываем никакие личные данные</strong>
        пользователей, такие как адреса электронной почты, имена, номера телефонов, адреса проживания или
        любую другую информацию, которая может идентифицировать вас лично.
      </p>
      <p>
        Наш сервис разработан таким образом, чтобы функционировать без необходимости сбора или хранения
        ваших персональных данных. Мы не используем файлы cookie для отслеживания вашей активности или
        сбора личной информации.
      </p>

      <h3>Данные об использовании (неперсонализированные)</h3>
      <p>
        Мы можем собирать анонимные, агрегированные данные об использовании сервиса, которые не могут быть
        связаны с конкретным пользователем. Эти данные используются исключительно для улучшения
        функциональности и производительности нашего сервиса, например, для анализа общих тенденций
        использования или выявления технических проблем. Примеры таких данных могут включать:
      </p>
      <ul>
        <li>Тип браузера и версия</li>
        <li>Тип устройства</li>
        <li>Время, проведенное на определенных страницах (без привязки к пользователю)</li>
        <li>Общие статистические данные о взаимодействии с сервисом</li>
      </ul>
      <p>
        Эти данные полностью анонимны и не содержат никакой информации, которая могла бы идентифицировать вас.
      </p>

      <h2>Передача данных</h2>
      <p>
        Поскольку мы не собираем и не храним личные данные, нет никаких личных данных для передачи.
        Мы не передаем никакую информацию третьим лицам.
      </p>

      <h2>Безопасность данных</h2>
      <p>
        Хотя мы не обрабатываем личные данные, мы принимаем все разумные меры для обеспечения безопасности
        нашего сервиса и защиты любой неперсонализированной информации от несанкционированного доступа,
        изменения, раскрытия или уничтожения.
      </p>

      <h2>Коммерчески чувствительная информация</h2>
      <p>
        Любая информация, которую вы вводите в наш сервис, связанная с вашими коммерческими запросами,
        проектами или другими чувствительными данными, обрабатывается с максимальной конфиденциальностью.
        Эта информация используется исключительно для предоставления вам запрошенных услуг и не передается
        третьим лицам ни при каких обстоятельствах. Мы не храним эту информацию дольше, чем это необходимо
        для выполнения вашего запроса.
      </p>

      <h2>Ссылки на другие сайты</h2>
      <p>
        Наш Сервис может содержать ссылки на другие сайты, которые не управляются нами. Если вы нажмете
        на стороннюю ссылку, вы будете перенаправлены на сайт этой третьей стороны. Мы настоятельно
        рекомендуем вам ознакомиться с Политикой конфиденциальности каждого сайта, который вы посещаете.
        Мы не контролируем и не несем ответственности за содержание, политику конфиденциальности или
        практику любых сторонних сайтов или служб.
      </p>

      <h2>Конфиденциальность детей</h2>
      <p>
        Наш Сервис не предназначен для лиц младше 18 лет. Поскольку мы не собираем личные данные,
        мы не собираем информацию о детях.
      </p>

      <h2>Изменения в настоящей Политике конфиденциальности</h2>
      <p>
        Мы можем время от времени обновлять нашу Политику конфиденциальности. Мы уведомим вас о любых
        изменениях, опубликовав новую Политику конфиденциальности на этой странице.
        Вам рекомендуется периодически просматривать настоящую Политику конфиденциальности на предмет
        любых изменений. Изменения в настоящей Политике конфиденциальности вступают в силу с момента
        их публикации на этой странице.
      </p>

      <h2>Свяжитесь с нами</h2>
      <p>
        Если у вас есть какие-либо вопросы по поводу настоящей Политики конфиденциальности, пожалуйста,
        свяжитесь с нами по адресу: support@example.com
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;